import Dropdown from '@anm/components/Dropdown';
import useIsMountedCheck from '@anm/hooks/useIsMountedCheck';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import vtConfig from '../../../../config';
import { userSelectors } from '../../../../store/modules/user';
import UserBlock from '../../../UserBlock';

import DropdownContent, { ListItem } from './DropdownContent';
import { DropdownButtonWrapper, UserBlockContainer } from './Wrapper';

const {
  urls: { wave: waveUrl }
} = vtConfig();

type GetUserMenuListProps = { isSemrushUser: boolean; isTeamUser: boolean };
const getUserMenuList = ({ isSemrushUser, isTeamUser }: GetUserMenuListProps) =>
  [
    isTeamUser && {
      title: 'Manage team',
      href: `${waveUrl}account/manage-team`
    },
    !isSemrushUser && {
      title: 'My profile',
      href: `${waveUrl}account/profile`
    },
    {
      title: 'Subscription',
      href: `${waveUrl}subscription`
    }
  ].filter(Boolean) as ListItem[];

const ProfileMenuDropdown: FC = () => {
  const isMounted = useIsMountedCheck();
  const isSemrushUser = useSelector(userSelectors.isSemrushUser);
  const isTeamUser = !!useSelector(userSelectors.selectTeamId);
  const userMenuList = getUserMenuList({ isSemrushUser, isTeamUser });

  return (
    <DropdownButtonWrapper>
      <Dropdown
        autoClose={false}
        openByAction="hover"
        openerVariant="default"
        direction="to-top-center"
        renderContent={() => <DropdownContent list={userMenuList} />}
      >
        {isMounted && (
          <UserBlockContainer>
            <UserBlock />
          </UserBlockContainer>
        )}
      </Dropdown>
    </DropdownButtonWrapper>
  );
};

export default ProfileMenuDropdown;
